import { Button, TextField } from "@material-ui/core";
import Box from "@mui/material//Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import cx from 'clsx';
import { makeStyles } from "@material-ui/core/styles";
import { useBouncyShadowStyles } from '@mui-treasury/styles/shadow/bouncy';

import { useState } from "react";
import { axiosWithAuth } from "../../Helpers/AxiosWithAuth";

export const CreateAccount = () => {
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [success, setSuccess] = useState(false);

	const onSubmit = (e) => {
		e.preventDefault();
		const creds = { username, password };

		axiosWithAuth()
			.post(`/api/auth/register`, creds)
			.then((res) => {
				setSuccess(true);
			})
			.catch((err) => console.log(err.message));

		setUsername("");
		setPassword("");
	};

	const styles = makeStyles(() => ({
		root: {
			maxWidth: 304,
			margin: 'auto',
			boxShadow: 'none',
			borderRadius: 0,
		},
		content: {
			padding: 24,
		},
		cta: {
			marginTop: 24,
			textTransform: 'initial',
		},
	}));

	const shadowStyles = useBouncyShadowStyles();

	return (
		<div className="createaccount-container">
			<Box mt={2} sx={{ minWidth: 275, maxWidth: 675 }}>
				<Card variant="outlined" className={cx(styles.root, shadowStyles.root)}>
					<CardContent>
						<Typography variant="h4" component="h2" gutterBottom>
							Create New Account
						</Typography>
						<form>
							<TextField
								id="username-input"
								name="username"
								label="Username"
								type="text"
								value={username}
								onChange={(e) => setUsername(e.target.value)}
							></TextField>
							<TextField
								id="password-input"
								name="password"
								label="Password"
								type="password"
								value={password}
								onChange={(e) => setPassword(e.target.value)}
							></TextField>{' '}
							<Button
								variant="contained"
								color="primary"
								size="large"
								className={cx(styles.root, shadowStyles.root, "button")}
								onClick={onSubmit}
							>
								Create Account
							</Button>
						</form>
						{success === true ? (
							<div>account created successfully, please login</div>
						) : (
							<div></div>
						)}
					</CardContent>
				</Card>
			</Box>
		</div>
	);
};

export default CreateAccount;
